import { useContext } from "react";

import { ContentContext, type ContentState } from "../context/contentState.js";

export function useContent(): ContentState {
  const context = useContext(ContentContext);

  if (!context) {
    throw new Error("useContent must be used inside <ContentProvider>.");
  }

  return context;
}
